import { useEffect } from 'react';

const useSendDimensionsToParent = ({
  isReady = false,
  contentRef = null,
  type = 'containerDimensions',
}) => {
  const isInIframe = window.parent !== window;

  useEffect(() => {
    if (!isInIframe || !isReady || !contentRef?.current) return;
    const sendDimensions = () => {
      const { scrollWidth, scrollHeight } = contentRef.current;
      sendDimensionsToParent(scrollWidth, scrollHeight);
    };

    sendDimensions();

    window.addEventListener('resize', sendDimensions);

    return () => {
      window.removeEventListener('resize', sendDimensions);
    };
  }, [isReady]);

  const sendDimensionsToParent = (width, height) => {
    window.parent.postMessage({ key: type, value: { width, height } }, '*');
  };

  return contentRef;
};

export default useSendDimensionsToParent;
